module.exports = __webpack_public_path__ + "img/picture5.01bc2ddb.png";